export namespace Theme {
  enum Colors {
    white = '#FFFFFF',
    lightGrey = '#FBFDFB',
    grey = '#BCBDBC',
    black = '#000000',

    red = '#DB0007',
    orange = '#FFBC0D',
    yellow = '#FFCD4B',
    green = '#004E31',

    lightPurple = '#863399',
    purple = '#7c3894'
  }

  enum Aliases {
    disabled = Colors.grey,
    border = Colors.grey,
    text = Colors.black,
    error = Colors.red
  }

  export const color = {
    ...Aliases,
    ...Colors
  };

  export const font = {
    family: {
      speedee: 'Speedee',
      condensed: 'Speedee Condensed'
    },

    style: {
      normal: 'normal',
      italic: 'italic'
    },

    weight: {
      regular: 400,
      bold: 700,
      black: 900
    }
  };

  export const rems = (px: number) => `${px * 0.0625}rem`;

  export const breakpoint = {
    md: '@media only screen and (max-width: 1199px)',
    sm: '@media only screen and (max-width: 1023px)',
    xs: '@media only screen and (max-width: 359px)'
  };
}
